import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import PlanDetails from './components/PlanDetails';
import QuienesSomosMejorado from './components/QuienesSomos.js';
import Contacto from './components/Contacto.js';
import { FaWhatsapp } from 'react-icons/fa';
import ScrollToTop from './components/ScrollToTop';




function App() {
  return (
    <Router>
            <ScrollToTop />

      <a
        href="https://wa.me/+56983221037" // Reemplaza con el número de WhatsApp
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={50} />
      </a>
      
      <div className="App flex flex-col min-h-screen" >
        <Header />
        <Routes>
          {/* Ruta principal que muestra los componentes principales */}
          <Route
            path="/"
            element={
              <>
                <Home />
              </>
            }
          />

          {/* Ruta dinámica para los detalles de cada plan */}
          <Route path="/PlanesDeServicio/:planId" element={<PlanDetails />} />
            
            {/* Ruta para la página Quienes Somos */}
          <Route path="/QuienesSomos" element={<QuienesSomosMejorado />} />
              
              {/* Ruta para la página de Contacto con componente reseñá */}
              <Route path="/Contacto" element={<div><Contacto /></div>} />

          
          
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
